module.exports = __webpack_public_path__ + "img/ui.8e018dde.png";